import React from "react";

export const IntroCircle = props => {
  return (
    <div className="intro intro-name" onClick={props.onClick}>
      <h1 id="hello">Hi, I'm Derek</h1>
      <h3>A Full Stack Web Developer</h3>
      <hr />
      <ul>
        <li>React</li>
        <li>Node</li>
        <li>Express</li>
        <li>MongoBD (+Mongoose)</li>
        <li>jQuery</li>
        <li>HTML/CSS</li>
        <li>MySQL (+Sequelize)</li>
        <li>APIs/JSON</li>
      </ul>
    </div>
  );
};
